import { prefix } from ".";
import { DropdownMenu } from "react-vant";
import ZhHKIcon from "../svg/ZhHkIcon";
import ZhCNIcon from "../svg/ZhCnIcon";
import EnIcon from "../svg/Enicon";
import { useState } from "react";
import i18n, { supportedLngs } from "@/i18n";
import langs from "@/i18n/langs";
import dayjs from "dayjs";
import { Link, useNavigate } from "react-router-dom";
import React from "react";
import HeaderIcon from "../svg/HeaderIcon";

interface IHeaderProps {
  logo?: string;
}

const Header: React.FC<IHeaderProps> = (_props) => {
  const navigate = useNavigate();
  const [value, setValue] = useState<Record<string, string | number>>({
    key: i18n.language
  });

  const areaCodes = [
    {
      key: 'zh-HK',
      label: '繁體中文',
      icon: <ZhHKIcon />
    },
    {
      key: 'zh-CN',
      label: '简体中文',
      icon: <ZhCNIcon />
    },
    {
      key: 'en',
      label: 'English',
      icon: <EnIcon />
    },
  ]

  const options = areaCodes.map(item => {
    return {
      text: <div className={`${prefix}-language-item`} key={item.key}>
        <span className={`${prefix}-language-item-img`}>
          {item.icon}
        </span>
        <span className={`${prefix}-language-item-text`}>
          {item.label}
        </span>
      </div>,
      value: item.key,
    }
  });

  const changeLanguage = (lng: string) => {
    if (!supportedLngs.includes(lng)) {
      return;
    }

    let pathname = window.location.pathname;
    const pathnameSplit = pathname.split('/');
    let lang = '';
    if (pathnameSplit.length > 1 && pathnameSplit[1]) {
      lang = pathnameSplit[1];
      lang = lang.replaceAll('_', '-');
    }

    if (lang === lng) {
      return;
    }

    if (lang && langs.includes(lang.toLocaleLowerCase())) {
      pathname = pathname.replace(`/${lang}`, '');
    }

    if (pathname.startsWith('/')) {
      pathname = `/${lng}${pathname}`;
    } else {
      pathname = `/${lng}/${pathname}`;
    }

    // 保留查询参数
    const search = window.location.search;

    dayjs.locale(lng.toLocaleLowerCase());
    i18n.changeLanguage(lng);
    navigate(`${pathname}${search}`);
  };

  const handleLanguageChange = (value: Record<string, string | number>) => {
    const key = value.key;
    if (typeof key === 'string') {
      changeLanguage(key);
    }
    setValue(value);
  };

  return (
    <div
      className={`${prefix}`}
    >
      <div
        className={`${prefix}-logo`}
        style={{
          background:
            'linear-gradient(310deg, #57B5EA 10.37%, #2871FF 84.21%)',
        }}
      >
        <HeaderIcon />
      </div>
      <div className={`${prefix}-title`}>
        <Link to={'https://wonder.app'}>Powered by Wonder</Link>
      </div>
      <div className={`${prefix}-language`}>
        <DropdownMenu
          direction='up'
          value={value}
          onChange={handleLanguageChange}
        >
          <DropdownMenu.Item name="key" options={options} />
        </DropdownMenu>
      </div>
    </div>
  )
};

export default React.memo(Header);